import React from 'react';
import Script from 'next/script';

import { IOutgrowFields } from '@/types/contentful';

export default function Sidenote({ code }: Partial<IOutgrowFields>) {
  return code ? (
    <>
      <div
        dangerouslySetInnerHTML={{ __html: code || '' }}
        data-testid="outgrow-sidenote"
      />
      <Script
        id="outgrow-sidenote"
        strategy="afterInteractive"
        src="https://dyv6f9ner1ir9.cloudfront.net/assets/js/og_sidenote.js"
      />
    </>
  ) : null;
}
